import React, { createContext, useContext, useState } from 'react';

const MessageContext = createContext();

export const useMessageContext = () => useContext(MessageContext);

export const MessageProvider = ({ children }) => {
    const [updateMessages, setUpdateMessages] = useState(false);

    const toggleUpdateMessages = () => {
        setUpdateMessages(prevState => !prevState);
    };

    return (
        <MessageContext.Provider value={{ updateMessages, toggleUpdateMessages }}>
            {children}
        </MessageContext.Provider>
    );
};
